import { ThemeOptions } from '@mui/material';

export const commonTypography: ThemeOptions['typography'] = {
  fontFamily: 'Noto Sans Hebrew',
  allVariants: {
    lineHeight: 1.66,
    letterSpacing: '0.4px'
  },
  body1: {
    lineHeight: 1.35
  },
  body2: {
    lineHeight: 1.35
  },
  subtitle2: {
    fontWeight: 700,
    fontSize: 15,
    lineHeight: 1.66
  },
  caption: {
    textAlign: 'center'
  }
};
